import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionCacheRegistry {
  private readonly resetFns = new Set<() => void>();

  register(reset: () => void): void {
    this.resetFns.add(reset);
  }

  resetAll(): void {
    this.resetFns.forEach(reset => reset());
  }
}
